import { UserColor } from 'src/models/resort/UserColor';

export function getResortUserColor(key?: number): UserColor {
  switch (key) {
    case 1:
      // brown
      return {
        main: '#857B73',
        dark: '#73675E',
        text: '#4D413A',
        textSub: '#665C55',
        textLight: '#6B5B52',
        ribbon: '#73655C',
        line: '#897C6A',
        deco: { green: '#9C8989', red: '#9F9388', blue: '#9A9884' }
      };
    case 2:
      // red
      return {
        main: '#E87D89',
        dark: '#CD626E',
        text: '#A43F4A',
        textSub: '#CB5E6A',
        textLight: '#AE5661',
        ribbon: '#D15A67',
        line: '#AC8B7C',
        deco: { green: '#D998BE', red: '#FC9595', blue: '#F2A685' }
      };
    case 3:
      // orange
      return {
        main: '#EB995E',
        dark: '#D08048',
        text: '#9E5420',
        textSub: '#BF7845',
        textLight: '#B06E3F',
        ribbon: '#D38043',
        line: '#B49475',
        deco: { green: '#F7B46A', red: '#DECC73', blue: '#CAD17D' }
      };
    case 4:
      // yellow
      return {
        main: '#E4CA66',
        dark: '#C9AF4D',
        text: '#9C842C',
        textSub: '#B59E47',
        textLight: '#A79141',
        ribbon: '#CDB24A',
        line: '#AA9F75',
        deco: { green: '#FFD5AF', red: '#E6E785', blue: '#CEEAA6' }
      };
    case 5:
      // green
      return {
        main: '#AAC35F',
        dark: '#90A948',
        text: '#6A802D',
        textSub: '#899E4A',
        textLight: '#7E9144',
        ribbon: '#94AF44',
        line: '#949875',
        deco: { green: '#DAD281', red: '#C3DA81', blue: '#9DD897' }
      };
    case 6:
      // cyan
      return {
        main: '#81C3B2',
        dark: '#65A996',
        text: '#438372',
        textSub: '#65A996',
        textLight: '#599082',
        ribbon: '#5DAF9A',
        line: '#8F9D96',
        deco: { green: '#A3DA92', red: '#97E1CD', blue: '#AFC7F8' }
      };
    case 7:
      // purple
      return {
        main: '#A698D0',
        dark: '#8779B5',
        text: '#685899',
        textSub: '#8779B5',
        textLight: '#786C9B',
        ribbon: '#8D78CC',
        line: '#9D8C93',
        deco: { green: '#D99ECA', red: '#C7BCE8', blue: '#A4BCDB' }
      };
    case 0:
    default:
      // white
      return {
        main: '#FDFFF2',
        dark: '#DBD0C6',
        text: '#99887B',
        textSub: '#D3C6BC',
        textLight: '#99887B',
        ribbon: '#E6D9CF',
        line: '#B2A599',
        deco: { green: '#FAE3CF', red: '#F7EBCE', blue: '#EAF2C9' }
      };
  }
}
